/***********************************
  CheckboxRadios Module
************************************/

Quad.CheckboxRadios = ( function() {


  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    $( 'input' ).iCheck({
      checkboxClass: 'icheckbox',
      radioClass: 'iradio'
    });

  }


  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return {

    init: _init

  };

})();
